// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.epr-selector-ratings .epr-options {
  margin-left: 0.5rem;
}

.diff-rating-type {
  margin-bottom: 0.75rem;
}

.diff-grade-panel__label {
  color: #0A4064;
  font-size: 1.25rem;
  font-weight: 500;
  margin: 0 0 8px;
}

.diff-grade-panel {
  background: #fff;
  border-radius: 8px;
}
.diff-grade-panel .rating-column-description-wrapper {
  max-height: none;
}
.diff-grade-panel .rating-column-description-wrapper.hide {
  max-height: 0;
}
.diff-grade-panel .rating-column-description {
  margin-bottom: 8px;
}
.diff-grade-panel .rating-column-description p {
  margin: 0;
}
.diff-grade-panel .rating-table-btn-group {
  margin: 0 0 8px;
}
.diff-grade-panel .rating-table-btn-group .column-nav {
  padding: 0;
}

.diff-grade-panel__header {
  background: #EDF0F1;
  border-bottom: 2px solid #0A4064;
  border-radius: 8px 8px 0 0;
  padding: 0 16px;
}

.diff-grade-tabs__list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: -2px;
  position: relative;
  z-index: 1;
}

.diff-grade-tabs__btn {
  background: none;
  border: 2px solid transparent;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  color: #5c6770;
  cursor: pointer;
  font-weight: 500;
  padding: 8px 14px;
}
.diff-grade-tabs__btn:hover:not(.is-active) {
  background: rgba(192, 222, 240, 0.5);
  color: #0A4064;
}

.diff-grade-tabs__btn.is-active {
  background: #fff;
  border-color: #0A4064;
  border-bottom: 2px solid #fff;
  color: #0A4064;
  font-weight: 700;
  z-index: 2;
}

.diff-grade-panel__body {
  padding: 12px 16px 16px;
}

.diff-unsaved-hint {
  margin-bottom: 8px;
}

.diff-empty-setup {
  background-color: white;
  border: 1px solid #636161;
  border-radius: 5px;
  margin: 8px 0 16px;
  padding: 24px;
}

.diff-empty-setup__text {
  font-weight: 450;
}

.diff-empty-setup__btn {
  margin: 12px 0 0 -10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/DifferentiatedRatings.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,mBAAA;AAKJ;;AAFA;EACI,sBAAA;AAKJ;;AAFA;EACI,cDFM;ECGN,kBAAA;EACA,gBAAA;EACA,eAAA;AAKJ;;AAFA;EACI,gBAAA;EACA,kBAAA;AAKJ;AADI;EACI,gBAAA;AAGR;AADQ;EACI,aAAA;AAGZ;AACI;EACI,kBAAA;AACR;AACQ;EACI,SAAA;AACZ;AAGI;EACI,eAAA;AADR;AAEQ;EACI,UAAA;AAAZ;;AAKA;EACI,mBDtBI;ECuBJ,gCAAA;EACA,0BAAA;EACA,eAAA;AAFJ;;AAKA;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAFJ;AAII;EACI,oCAAA;EACA,cDlEE;ACgEV;;AAMA;EACI,gBAAA;EACA,qBDxEM;ECyEN,6BAAA;EACA,cD1EM;EC2EN,gBAAA;EACA,UAAA;AAHJ;;AAMA;EACI,uBAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,sBAAA;AAHJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"./global/Colors\";\n\n.epr-selector-ratings .epr-options {\n    margin-left: 0.5rem;\n}\n\n.diff-rating-type {\n    margin-bottom: 0.75rem;\n}\n\n.diff-grade-panel__label {\n    color: $dk-blue;\n    font-size: 1.25rem;\n    font-weight: 500;\n    margin: 0 0 8px;\n}\n\n.diff-grade-panel {\n    background: #fff;\n    border-radius: 8px;\n\n    // Allow tall item descriptions (on-level caps at 500px); still collapse on\n    // Show Student Comments so the table slides up like RatingGrid.\n    .rating-column-description-wrapper {\n        max-height: none;\n\n        &.hide {\n            max-height: 0;\n        }\n    }\n\n    .rating-column-description {\n        margin-bottom: 8px;\n\n        p {\n            margin: 0;\n        }\n    }\n\n    .rating-table-btn-group {\n        margin: 0 0 8px;\n        .column-nav {\n            padding: 0;\n        }\n    }\n}\n\n.diff-grade-panel__header {\n    background: $grey0;\n    border-bottom: 2px solid $dk-blue;\n    border-radius: 8px 8px 0 0;\n    padding: 0 16px;\n}\n\n.diff-grade-tabs__list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    margin-bottom: -2px;\n    position: relative;\n    z-index: 1;\n}\n\n.diff-grade-tabs__btn {\n    background: none;\n    border: 2px solid transparent;\n    border-bottom: none;\n    border-radius: 8px 8px 0 0;\n    color: #5c6770;\n    cursor: pointer;\n    font-weight: 500;\n    padding: 8px 14px;\n\n    &:hover:not(.is-active) {\n        background: rgba($pale-blue, 0.5);\n        color: $dk-blue;\n    }\n}\n\n.diff-grade-tabs__btn.is-active {\n    background: #fff;\n    border-color: $dk-blue;\n    border-bottom: 2px solid #fff;\n    color: $dk-blue;\n    font-weight: 700;\n    z-index: 2;\n}\n\n.diff-grade-panel__body {\n    padding: 12px 16px 16px;\n}\n\n.diff-unsaved-hint {\n    margin-bottom: 8px;\n}\n\n.diff-empty-setup {\n    background-color: white;\n    border: 1px solid $grey4;\n    border-radius: 5px;\n    margin: 8px 0 16px;\n    padding: 24px;\n}\n\n.diff-empty-setup__text {\n    font-weight: 450;\n}\n\n.diff-empty-setup__btn {\n    margin: 12px 0 0 -10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
